// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/css/log.css
// module id = 476
// module chunks = 41